var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("base-list", {
    attrs: {
      dataList: _vm.datas,
      size: _vm.size,
      tagLists: _vm.tagLists,
      searchName: "pc_biz_ote_lbl_quesbank",
      listId: "quesId",
    },
    on: { "to-list": _vm.toList, "to-more": _vm.toListMore },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (ref) {
          var list = ref.list
          return [
            _c("span", [
              _vm._v(
                _vm._s(
                  _vm.$t("pc_biz_ote_lbl_ques_number", [list.totalQuesQty])
                )
              ),
            ]),
            _c("span", { staticClass: "ml20" }, [
              _vm._v(_vm._s(list.createFullname || "--")),
            ]),
            _c("yxt-divider", { attrs: { direction: "vertical" } }),
            _c("span", [
              _vm._v(
                _vm._s(
                  _vm.$t("pc_kng_common_lbl_update_time", [list.updateTime])
                )
              ),
            ]),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }